import { call, put } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import { dropdownFetchListInProgress, dropdownFetchListDone, dropdownFetchError } from '../actions/actionCreatorsAdmin';
import { getDocs } from '../services/apiCommon';

export function* fetchDoc(fetchFn, ...args) {
  const result = yield call(fetchFn, ...args);
  if (result) {
    return result;
  }
  browserHistory.push('/admin/not_found');
}

export function* showProgressListArray(silent) {
  if (!silent) {
    yield put({ type: 'FETCH_LIST_DATA_ARRAY_INPROGRESS' });
  } else {
    yield put({ type: 'SILENT_FETCH_LIST_DATA_ARRAY_INPROGRESS' });
  }
}
export function* doneListArray(rows) {
  yield put({ type: 'FETCH_LIST_DATA_ARRAY_DONE', rows });
}
export function* showErrorListArray(error) {
  yield put({ type: 'FETCH_LIST_DATA_ARRAY_ERROR', error });
}


export function* showProgressListTable(silent) {
  if (!silent) {
    yield put({
      type: 'FETCH_LIST_TABLE_ROWS_INPROGRESS'
    });
  } else {
    yield put({
      type: 'SILENT_FETCH_LIST_TABLE_ROWS_INPROGRESS'
    });
  }
}
export function* doneListTable(data) {
  const { rows, total_rows } = data;
  yield put({
    type: 'FETCH_LIST_TABLE_ROWS_DONE',
    payload: {
      rows, total_rows
    }
  });
}
export function* showErrorListTable(error) {
  yield put({
    type: 'FETCH_LIST_TABLE_ROWS_ERROR', error
  });
}


export function* showProgressSaveRecord(silent) {
  yield call(clearSaveRecord);
  if (!silent) {
    yield put({ type: 'SAVE_RECORD_INPROGRESS' });
  }
}
export function* showProgressSaveAsRecord(silent) {
  if (!silent) {
    yield put({ type: 'SAVE_AS_RECORD_INPROGRESS' });
  }
}
export function* doneSaveRecord(result, message) {
  let payload = { result, message };
  yield put({
    type: 'SAVE_RECORD_DONE',
    ...payload
  });
}
export function* doneSaveAsRecord(result, message) {
  let payload = { result, message };
  yield put({
    type: 'SAVE_AS_RECORD_DONE',
    ...payload
  });
}
export function* showErrorSaveRecord(error) {
  yield put({ type: 'SAVE_RECORD_ERROR', error });
}
export function* showErrorSaveAsRecord(error) {
  yield put({ type: 'SAVE_AS_RECORD_ERROR', error });
}


export function* clearSaveRecord() {
  yield put({ type: 'CLEAR_SAVE_RECORD' });
}

export function* doneDataById(data, message, isCopy) {
  yield put({ type: 'FETCH_DATA_BY_ID_DONE', data: data, message: message, isCopy });
}
export function* showProgressDataById(silent) {
  if (!silent) {
    yield put({ type: 'FETCH_DATA_BY_ID_INPROGRESS' });
  }
}
export function* showErrorDataById(error, silent) {
  if (!silent) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error });
  }
}
export function* showMessageDataById(message) {
  yield put({ type: 'SHOW_MESSAGE_DATA_BY_ID', payload: message });
}


export function* doneDeleteRecord(id, docType) {
  yield put({ type: 'DELETE_RECORD_DONE', payload: { id, docType } });
}
export function* showProgressDeleteRecord(silent) {
  if (!silent) {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  }
}
export function* showErrorDeleteRecord(error, silent) {
  if (!silent) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}


export function* showProgressDropdownList(id, searchTerm) {
  yield put(dropdownFetchListInProgress(id));
}
export function* doneDropdownList(id, searchTerm, list) {
  yield put(dropdownFetchListDone(id, searchTerm, list));
}
export function* clearDropdown(id) {
  yield put({ type: 'CLEAR_DROPDOWN', id });
}
export function* showErrorDropdownList(id, searchTerm, error) {
  yield put(dropdownFetchError(id, error));
}

export function* fetchListing(app, action, list_type) {
  const { silent, filters } = action;
  yield showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      list_type,
    };
    const tableData = yield call(getDocs, app, dataParams);
    yield call(doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield showErrorListTable(error);
  }
}
